import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-remote-support',
  templateUrl: './remote-support.component.html'
  })
export class RemoteSupportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
